module.exports = __webpack_public_path__ + "static/media/no-friends-light.92d91560.svg";